<template lang="pug">
  .component-role
    .inner-content
      .row
        //.column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
        //pre {{item}}
        .column
          .label RL{{item.id}}
          .field {{item.name}}
        .column
          .label Description
          .field {{item.description}}
        .column.shrink.align-self-middle
          router-link(:to="{name:'role', params:{id:item.id}}")
            i.fa.fa-angle-right.fa-3x.action
</template>

<script>
  import Dropdown from '../structure/foundation/Dropdown'

  export default {
    name: 'Role',
    components: {Dropdown},
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Role.vue?a5918c42